export default __webpack_public_path__ + "static/media/pl.bcc1d6f9.svg";